import { useTranslations } from '@vocab/react';
import { Alert, TextLinkButton, Text } from 'braid-design-system';
import type { FC } from 'react';

import translations from './.vocab';

type Props = {
  onClick: () => void;
};

export const UnlockReferenceCheckAlert: FC<Props> = ({ onClick }) => {
  const { t } = useTranslations(translations);

  return (
    <Alert tone="info">
      <Text>
        {t(
          "You're viewing a limited report. To see the full responses, <TextLinkButton>upgrade to the standard report</TextLinkButton>.",
          {
            TextLinkButton: (children) => (
              <TextLinkButton onClick={onClick}>{children}</TextLinkButton>
            ),
          },
        )}
      </Text>
    </Alert>
  );
};
